import React, { useContext, useEffect, useState } from "react";
import { http } from "../services/httpService";
import config from "../services/config.json";
import { context } from "../context/context";
import NewsCommentTable from "../components/News/NewsCommentsTable";
import { NavLink } from "react-router-dom";
import { Button } from "antd";

const NewsComments = () => {
    // state
    const [comments, setComments] = useState([]);
    const [title, setTitle] = useState();
    const [loading, setLoading] = useState(false);
    // context
    const { selectedNewsId } = useContext(context);
    // useEffect
    useEffect(() => {
        setLoading(true);
        http.get(`${config.parkopoloApi}/api/News/${selectedNewsId}`)
            .then((res) => {
                setLoading(false);
                setTitle(res.data.result.title);
                setComments(res.data.result.comment);
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
            });
    }, [selectedNewsId]);

    return (
        <>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <h3>کامنت های {title}</h3>
                <NavLink to="/news">
                    <Button type="primary" danger>
                        بازگشت
                    </Button>
                </NavLink>
            </div>
            <NewsCommentTable comments={comments} loading={loading} />
        </>
    );
};

export default NewsComments;
